import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InviteUsersComponent } from './invite-user.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    InviteUsersComponent
  ],
})
export class InviteUserModule { }


// WEBPACK FOOTER //
// ./src/app/admin/invite-user/invite-user.module.ts